import _objectSpread from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
export default {
  name: 'jackpot',
  computed: _objectSpread({}, mapState(['isLogin'])),
  methods: {
    clickHandler: function clickHandler() {
      this.$parent.$refs.strategyPop.updateHandler(true);
    },
    payHandler: function payHandler() {
      window.location.href = 'https://film.qq.com/vip/act/cy/AqsHNxBp.html?ptag=cnyegg';
    }
  },
  settingKey: '福蛋抢钱攻略',
  setting: {
    背景图: '//puep.qpic.cn/vupload/0/20190115_1547540193629_8kfuh158qhl.png/0'
  }
};